module.exports = __webpack_public_path__ + "static/sleeping-dog-1dd74354986f21e57e8b92fd75414f6e.svg";